<template>
    <div class="favourites__empty-state">
        <Illustration xl image="/static/img/illustrations/favourites__empty-state.svg"/>
        <div class="favourites__empty-state-copy">
            {{ $t('welcome to Favourites page! You don\'t have any favorite tournaments yet.') | capitalize }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'EmptyState',
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/sportOffer/favourites/content/components/EmptyState.vue